// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"6820":"e608d8ad","8978":"642ff3cf"}[chunkId] + ".chunk.css");